import React from "react";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineDot from "@material-ui/lab/TimelineDot";

const CommonTimeLineItem = ({ children, last }) => (
  <TimelineItem>
    <TimelineSeparator>
      <TimelineDot color="grey" style={{ padding: 12 }} />
      {last ? <></> : <TimelineConnector />}
    </TimelineSeparator>
    <TimelineContent>{children}</TimelineContent>
  </TimelineItem>
);

export default CommonTimeLineItem;
